import React from 'react'
import type { SelectOption } from '@ztechapps/webui.input'
import { InlineDisplayContent, Select } from '@ztechapps/webui.input'
import type { PromptDialogProps } from './index'

export const ResetPasswordPromptDialog = ({ templateVariables, setPromptAction }: PromptDialogProps) => {
  const onChange = (e: string) => {
    setPromptAction(e)
  }

  return (
    <div style={{ textAlign: 'left' }}>
      <InlineDisplayContent label={'Select users'} help={'Select users to reset password'}>
        <Select
          options={templateVariables?.resetUsersPassword}
          onChange={(e: SelectOption) => {
            onChange(
              JSON.stringify({
                resetPasswordId: e?.value,
                username: e?.profile?.email,
                profileName: e?.label,
              })
            )
          }}
        />
      </InlineDisplayContent>
      <h5 className={'mt-2 text-warning'}>This will reset the password of the selected customer.</h5>
    </div>
  )
}
